import { handleSetDownloadModalStatus } from "../../../fileManager.actions";
import { downloadResource } from "../../../fileManager.function";
import CheckBox from "../../../../checkbox/checkbox.index";
import ConfirmationModal from "../../../../confirmationModal/confirmationModal.index";
import { useState } from "react";
import { ENVIRONMENT } from "../../../../../../environment";
import { useAppSelector } from "../../../../../../redux/hooks";
import { shallowEqual } from "react-redux";

export default function DownloadAlertModal(): JSX.Element {
    const { downloadModalStatus, selectedResources } = useAppSelector(
        ({ fileManager: { downloadModalStatus, selectedResources } }) => ({ downloadModalStatus, selectedResources }),
        shallowEqual
    );
    const [ignoreDownloadAlert, setIgnoreDownloadAlert] = useState(false);

    return (
        <ConfirmationModal
            modalType={"ACTION"}
            status={downloadModalStatus}
            onClose={() => {
                handleSetDownloadModalStatus(false);
                setIgnoreDownloadAlert(false);
            }}
            onSubmit={() => {
                downloadResource();
                handleSetDownloadModalStatus(false);
                if (ignoreDownloadAlert) localStorage.setItem("HAMRAHI_DOWNLOAD_ALERT", "1");
                setIgnoreDownloadAlert(false);
            }}
            submitButtonText="دانلود فایل"
            cancelButtonText="لغو"
            text={`${ENVIRONMENT.brandName} هیچ مسئولیتی دررابطه‌با فایل‌های مخرب ندارد! آیا می‌خواهید دانلود کنید؟`}
            rotateButtons={true}
        >
            <div className="flex gap-2 flex-col w-full mt-2">
                {selectedResources && selectedResources.length > 0 ? (
                    <div className="flex text-secondary-600 text-[13px] font-normal text-center justify-center">
                        {selectedResources.map((item: any) => item.name).join(", ")}
                    </div>
                ) : (
                    <></>
                )}
                <CheckBox label="دیگر نمایش نده" onChange={(val) => setIgnoreDownloadAlert(val)} defaultValue={ignoreDownloadAlert} />
            </div>
        </ConfirmationModal>
    );
}
